export const idlFactory = ({ IDL }) => {
  const Time = IDL.Int;
  const Event = IDL.Record({
    'principal' : IDL.Opt(IDL.Principal),
    'timestamp' : Time,
    'details' : IDL.Text,
    'eventType' : IDL.Text,
  });
  const TransactionStatus = IDL.Variant({
    'Failed' : IDL.Null,
    'Confirmed' : IDL.Null,
    'Pending' : IDL.Null,
  });
  const TransactionRecord = IDL.Record({
    'status' : TransactionStatus,
    'recipient' : IDL.Text,
    'timestamp' : Time,
    'txHash' : IDL.Text,
    'amount' : IDL.Nat,
  });
  const Wallet = IDL.Record({
    'balance' : IDL.Nat,
    'address' : IDL.Text,
    'lastReward' : IDL.Opt(Time),
  });
  const Error = IDL.Variant({
    'InvalidInput' : IDL.Null,
    'TransactionFailed' : IDL.Null,
    'InsufficientBalance' : IDL.Null,
    'Unauthorized' : IDL.Null,
    'SystemPaused' : IDL.Null,
    'RateLimitExceeded' : IDL.Null,
    'StateError' : IDL.Null,
  });
  const Result = IDL.Variant({ 'ok' : IDL.Null, 'err' : Error });
  const Airdrop = IDL.Service({
    'checkWalletBalance' : IDL.Func([], [], []),
    'getConfig' : IDL.Func(
        [],
        [
          IDL.Record({
            'minWallets' : IDL.Nat,
            'minRewardInterval' : IDL.Int,
            'minWalletBalanceIncrease' : IDL.Nat,
            'maxWallets' : IDL.Nat,
          }),
        ],
        ['query'],
      ),
    'getEventLog' : IDL.Func([], [IDL.Vec(Event)], ['query']),
    'getExtendedConfig' : IDL.Func(
        [],
        [
          IDL.Record({
            'lastWalletBalance' : IDL.Nat,
            'lastAirdropTime' : Time,
            'tokenAddress' : IDL.Text,
            'walletAddress' : IDL.Text,
            'isSystemPaused' : IDL.Bool,
            'solanaEndpoint' : IDL.Text,
          }),
        ],
        ['query'],
      ),
    'getSystemStatus' : IDL.Func(
        [],
        [
          IDL.Record({
            'lastWalletBalance' : IDL.Nat,
            'lastAirdropTime' : Time,
            'lastHeartbeatTime' : Time,
            'isSystemPaused' : IDL.Bool,
          }),
        ],
        ['query'],
      ),
    'getTransactionLog' : IDL.Func([], [IDL.Vec(TransactionRecord)], ['query']),
    'getWalletBalance' : IDL.Func([], [IDL.Nat], []),
    'getWallets' : IDL.Func([], [IDL.Vec(Wallet)], ['query']),
    'setOwner' : IDL.Func([IDL.Principal], [Result], []),
    'triggerAirdrop' : IDL.Func([], [], []),
  });
  return Airdrop;
};
export const init = ({ IDL }) => { return []; };
